export enum Allergens {
  Celery = "Celery",
  Lupin = "Lupin",
  SesameSeed = "SesameSeed",
  Wheat = "Wheat",
  Crustaceans = "Crustaceans",
  Milk = "Milk",
  Shelfish = "Shelfish",
  Egg = "Egg",
  Molluscs = "Molluscs",
  Soy = "Soy",
  Fish = "Fish",
  Mustard = "Mustard",
  Sulphites = "Sulphites",
  Gluten = "Gluten",
  Peanut = "Peanut",
  TreeNuts = "TreeNuts"
}